var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12V6a4 4 0 00-8 0v6h8zM4 6v6H.5a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5H16V6A6 6 0 004 6zm9 14a3 3 0 11-6 0 3 3 0 016 0z"
  })));
}

export default __webpack_public_path__ + "3e31d8c25311425cc3513bd7e437cc49.svg";
export { SvgLock as ReactComponent };